import { PanelLeft } from 'lucide-react';

import { useSidebar } from '@/components/ui/sidebar';

export function SidebarTrigger() {
  const { toggleSidebar, open } = useSidebar();

  return (
    <button onClick={toggleSidebar}>
      {!open ? <PanelLeft size={16} /> : <PanelLeft size={16} />}
    </button>
  );
}
